import React from 'react';
import { useEffect, useState } from 'react';
import { getPlants } from '../../services/plantService';

function AvailablePlants() {
    const [plants, setPlants] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPlants()
            .then((response) => {
                setPlants(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen text-xl text-gray-300">
                Loading...
            </div>
        );
    }
    console.log('Plants:', plants);
    return (
        <div className="p-6 bg-gray-800 text-gray-300 rounded-lg shadow-lg">
            <h2 className="mb-4 text-2xl font-bold text-white">Available Plants</h2>

            {/* List all available plants */}
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {plants.map((plant) => (
                    <div key={plant.id} className="bg-gray-700 rounded-lg p-4 shadow-md">
                        <h3 className="text-lg font-bold text-white">{plant.name}</h3>
                        <p className="text-sm text-gray-400"><span className="font-bold">Botanical Name: </span>{plant.botanical_name}</p>
                        {/* Show the image */}
                        <img src={plant.picture_url} alt={plant.name} className="w-full h-40 object-cover mt-2" />

                        <p className="text-sm text-gray-400 pt-4">Description: {plant.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AvailablePlants;
